module.exports = __webpack_public_path__ + "static/img/DSC_2660.d4fc827.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2660.jpg
// module id = 268
// module chunks = 0